import { Component } from '@angular/core';
import { Sidebar } from '@shared/sidebar/sidebar';
import { Navbar } from '@shared/navbar/navbar';
import { Footer } from '@shared/footer/footer';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-home-layout',
  imports: [Sidebar, Navbar, Footer, RouterOutlet],
  templateUrl: './home-layout.html',
  styleUrl: './home-layout.scss'
})
export class HomeLayout {}
